
/**
 * "Hacky" in that it doesn't follow the canonical "school URL" format, but will resolve to that after a redirect.
 * See comments within method for details.
 * @param schoolId
 * @returns {string}
 */
export const buildHackySchoolPageUrl = (schoolId) => {
    // Hack: the canonical "school URL" format is:
    //   `/schools/${STATE_NAME}/${DISTRICT_NAME}/${SCHOOL_NAME}/${ID}`
    //
    // But we only *need* the schoolId. So this function lets us build a working-but-sleazy URL from just the schoolId
    // by filling the ignored-but-required fields in with hyphens.
    return baseURL + 'schools/-/-/-/' + schoolId;
}
